/**
 * Shared cache tag sets for route operations.
 * Centralizes the cache invalidation patterns used by bulk actions,
 * ScheduleStopDialog, and other route-modifying flows.
 */
import {
  CACHE_TAG_ROUTES,
  CACHE_TAG_ROUTES_METADATA_BY_DATE,
  CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_ROUTES_GEOJSON,
  CACHE_TAG_CONFIGURED_SERVICES_LIST,
  CACHE_TAG_MASTER_ROUTE_META,
  CACHE_TAG_MASTER_ROUTE_VERSIONS,
} from 'api/cacheTagTypes'

/** Base tags invalidated by any route modification (resequence, move days, optimize, etc.) */
export const ROUTE_BASE_INVALIDATION_TAGS = [CACHE_TAG_ROUTES, CACHE_TAG_ROUTES_METADATA_BY_DATE]

/** Tags for assign/move/unassign operations (includes unassigned work orders) */
export const ROUTE_ASSIGN_INVALIDATION_TAGS = [...ROUTE_BASE_INVALIDATION_TAGS, CACHE_TAG_ROUTES_UNASSIGNED_WORK_ORDERS]

/** Tags for master sequence publish — matches the master sequence editor's invalidation */
export const ROUTE_MASTER_PUBLISH_INVALIDATION_TAGS = [
  ...ROUTE_ASSIGN_INVALIDATION_TAGS,
  CACHE_TAG_MASTER_ROUTE_META,
  CACHE_TAG_MASTER_ROUTE_VERSIONS,
  CACHE_TAG_ROUTES_STOPS,
  CACHE_TAG_ROUTES_GEOJSON,
]

/** Tags for schedule stop dialog (includes configured services list) */
export const ROUTE_SCHEDULE_STOP_INVALIDATION_TAGS = [...ROUTE_MASTER_PUBLISH_INVALIDATION_TAGS, CACHE_TAG_CONFIGURED_SERVICES_LIST]
